const Utils ={
  /**
   * 获取url中的参数
   * @param {*} $url 
   */
  getUrlAllParams:function($url){
    // 解决乱码问题
    var url = decodeURI($url);
    let formattedParams = {};
    const params = url.split("?")[1].split("&");

    for ( let i = 0; i < params.length; i ++) {
      formattedParams[params[i].split("=")[0]] = params[i].split("=")[1];
    }
    return formattedParams;
  }

}

export default Utils